import React from 'react';
import { ClassAssembly8E2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly8E2026/>;
  };
  
  export default ClassAssemblyPage;